import { showHttpError } from '@calendly/alert'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { createExport } from './api'

const initialState = { confirmationOpen: false }

const slice = createSlice({
  name: 'eventTypeExport',
  initialState,
  reducers: {
    openConfirmation(state) {
      state.confirmationOpen = true
    },
    closeConfirmation(state) {
      state.confirmationOpen = false
    },
  },
})

export const createDelayedExport = createAsyncThunk(
  '/api/organization/event_types/export',
  async (_, { dispatch, rejectWithValue }) => {
    const [success, response] = await createExport()

    if (success && response.location === 'inline' && !!response.url) {
      window.open(response.url, '_self')
      return rejectWithValue()
    }

    if (success) {
      return dispatch(slice.actions.openConfirmation())
    }

    return dispatch(showHttpError(response))
  }
)

export const confirmationOpenSelector = (state) => state.eventTypeExport.confirmationOpen

export const { closeConfirmation } = slice.actions
export const reducer = slice.reducer
